// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:38:31

export default {
  "id": "jailbreak-escape-from-prison",
  "slug": "jailbreak-escape-from-prison",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e5c41772e13f49d891a9bff3ea726943-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e5c41772e13f49d891a9bff3ea726943/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "JailBreak : Escape from Prison",
      "description": "Experience the thrill of jailbreak escape, find a way out to freedom in our adventure filled jailbreak games! In this exciting jailbreak escape journey, you’ll take on the role of a character trapped behind jail bars, where every level presents unique challenges and exciting mini games, leading to the final goal of prison escape. Your goal in this prison games? Outsmart the system, solve clever puzzles, and find a way out in this immersive jailbreak escape adventure.\n",
      "instructions": "Move with Joystick and use jump buttons",
      "genres": [
        "Adventure",
        "Simulation"
      ],
      "tags": [
        "3d",
        "breakout",
        "escape"
      ]
    },
    "zh-CN": {
      "title": "越狱：逃离监狱",
      "description": "体验越狱逃亡的刺激，在我们的冒险越狱游戏中找到通往自由的道路！在这场激动人心的越狱逃亡之旅中，你将扮演一个被困在铁窗后的角色，每个关卡都带来独特的挑战和令人兴奋的小游戏，最终目标是逃离监狱。在这款监狱游戏中，你的目标是智胜系统，解决巧妙的谜题，在这场沉浸式的越狱逃亡冒险中找到出路。",
      "instructions": "使用摇杆移动并使用跳跃按钮",
      "genres": [
        "冒险",
        "模拟"
      ],
      "tags": [
        "三维",
        "破墙",
        "逃脱"
      ]
    },
    "zh-TW": {
      "title": "獄斷：逃出監獄",
      "description": "體驗越獄逃亡的刺激，在充滿冒險的越獄遊戲中尋找自由之路！在這場刺激的越獄逃亡之旅中，你將扮演一個被困在籠籠中的角色，每個關卡都呈現獨特的挑戰和興奮的小遊戲，最終目標是逃出監獄。在這款監獄遊戲中你的目標是？智勝系統，解開巧妙的謎題，並在這場沉浸式的越獄逃亡冒險中找到出口。",
      "instructions": "使用摇杆移動並使用跳躍按鈕",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "3D",
        "打砖块",
        "逃脫"
      ]
    },
    "zh-HK": {
      "title": "監獄大逃亡：獄中脫逃",
      "description": "體驗脫逃的刺激，在充滿冒險的脫逃遊戲中尋找自由之道！在這個刺激的脫逃冒險旅程中，你將扮演一名被困在籠籠後的角色，每個關卡都呈現獨特的挑戰和令人興奮的小遊戲，引領你達到最終目標——監獄脫逃。你在這款監獄遊戲中的目標是？智勝系統，解開巧妙的謎題，並在這個沉浸式的脫逃冒險中尋找脫逃之道。",
      "instructions": "使用摇杆移動及按跳躍按鈕",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "3D",
        "破滙",
        "逃離"
      ]
    },
    "ja": {
      "title": "ジャイルブレイク：刑務所から脱出",
      "description": "ジャイルブレイク脱獄のスリルを体験し、冒険に満ちたジャイルブレイクゲームで自由への道を見つけよう！この興奮的なジャイルブレイク脱獄の旅では、刑務所の壁に捕らわれたキャラクターとして、レベルごとにユニークな挑戦と楽しいミニゲームが用意され、最終的な刑務所脱出を目指します。この刑務所ゲームの目標は何か？システムをだます、賢いパズルを解き、没入感のあるジャイルブレイク脱獄アドベンチャーから逃げ出す方法を見つけることです。",
      "instructions": "ジョイスティックで移動し、ジャンプボタンを使用して",
      "genres": [
        "アドベンチャー",
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "ブロークアウト",
        "脱出"
      ]
    },
    "ko": {
      "title": "제일브레이크 : 감옥 탈출",
      "description": "감옥 탈출의 흥분을 경험해보세요! 우리의 모험에 가득한 탈출 게임에서 자유로움의 길을 찾아보세요! 이 흥미진진한 탈출 탐험에서는 감옥의 칸막이에 갇힌 캐릭터의 역할을 맡게 되며, 각 레벨마다 독특한 도전과 흥미로운 미니 게임이 마지막 목표인 감옥 탈출로 이어집니다. 이 감옥 게임의 목표는 무엇인가요? 시스템을 속이고, 지혜로운 퍼즐을 풀고, 이 몰입형 탈출 탐험에서 탈출하는 길을 찾아보세요.",
      "instructions": "조이스틱으로 이동하고 점프 버튼 사용",
      "genres": [
        "모험",
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "브레이크아웃",
        "탈출"
      ]
    },
    "fr": {
      "title": "JailBreak : Échappe-toi de prison",
      "description": "Expérimentez le frisson de l'évasion de prison, trouvez un chemin vers la liberté dans nos jeux d'évasion de prison remplis d'aventures ! Dans ce voyage d'évasion passionnant, vous incarnez un personnage coincé derrière des barreaux, où chaque niveau présente des défis uniques et des mini-jeux captivants, menant au but final de l'évasion de prison. Votre objectif dans ces jeux de prison ? Surprendre le système, résoudre des puzzles ingénieux et trouver un chemin de fuite dans cette aventure immersive d'évasion de prison.",
      "instructions": "Se déplacer avec le joystick et utiliser les boutons de saut",
      "genres": [
        "Aventure",
        "Simulation"
      ],
      "tags": [
        "3D",
        "Breakout",
        "Échappée"
      ]
    }
  }
};
